import { render, staticRenderFns } from "./formCode.vue?vue&type=template&id=7fa8e3ba&scoped=true&"
import script from "./formCode.vue?vue&type=script&lang=js&"
export * from "./formCode.vue?vue&type=script&lang=js&"
import style0 from "./formCode.vue?vue&type=style&index=0&id=7fa8e3ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa8e3ba",
  null
  
)

export default component.exports